import { useMutation, useQueryClient } from "react-query";
import authAPI from "../authAPI";

export const useRevokeFeideWhitelist = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, reason }) => authAPI.revokeFeideWhitelist(id, reason),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["feideWhitelists"]);
        queryClient.invalidateQueries(["feideWhitelist"]);
      },
    }
  );
};
